import React, { useState } from "react";
import TestimonialsCard from "./TestimonialsCard";

// Testimonials data
const testimonials = [
  {
    topBg: "",
    rating: 5,
    content: (
      <>
        <span style={{ fontWeight: "bold", color: "black" }}>
          Lovely out of town and very comfortable villas. Hosts
          and staff are wonderful and the food is excellent.
        </span>
        <br />
        The owners and staff are extremely warm and friendly.
        The hospitality and food are excellent, we thoroughly
        enjoyed two delicious dinner meals, plus plentiful
        breakfast. The rooms are very well appointed and
        spacious. The bed was super comfy. The location is out
        of town and very peaceful. Very good value for money. <br /><br />
      </>
    ),
    authorImg: "assets/images/reviews/justine-s.jpg?v=20260924",
    authorName: "Christopher",
    authorDesignation: "November 2024",
    bottomBg: "assets/images/shapes/testi-card-bg-1-2.png?v=20260924",
    bottomBgHover: "assets/images/shapes/testi-card-bg-1-2-hover.png?v=20260924",
    wowDelay: "000ms",
  },
  {
    topBg: "assets/images/shapes/testi-card-bg-1-1.png?v=20260924",
    rating: 5,
    content: (
      <>
        <span style={{ fontWeight: "bold", color: "black" }}>
          Nice view, friendly staff - a lovely quiet place.
        </span>
        <br />
        The staff and the owner were lovely - all very kind and
        helpful. Out room was clean and comfortable. The view
        was very nice, we managed to see a wild porcupine, wild
        pigs, wild monkeys and some squirrels just from the
        terrace. The food (they also offer dinner) was very
        good, too. The location is a bit out of town, but if you
        want some quite and enjoy fresh air it's the best you
        can do. I totally recommend. Another plus: The owner
        will help you book any sorts of trips for a reasonable
        price.
      </>
    ),
    authorImg: "assets/images/reviews/default-avatar-2020-21.jpg?v=20260924",
    authorName: "Andrea",
    authorDesignation: "November 2024",
    bottomBg: "assets/images/shapes/testi-card-bg-1-2.png?v=20260924",
    bottomBgHover: "assets/images/shapes/testi-card-bg-1-2-hover.png?v=20260924",
    wowDelay: "100ms",
  },
  {
    topBg: "assets/images/shapes/testi-card-bg-1-1.png?v=20260924",
    rating: 5,
    content: (
      <>
        <span style={{ fontWeight: "bold", color: "black" }}>
          Absolute gem! A must stay in Kandy! Pathi and his
          family go above and beyond!
        </span>
        <br />
        Amazing host, beautiful location in the hills, away from
        the city, but accessible by tuk tuk! Food was
        incredible! Absolute recommend{" "}
      </>
    ),
    authorImg: "assets/images/reviews/rachel.jpg?v=20260924",
    authorName: "Rachellovestravel",
    authorDesignation: "September 2024",
    bottomBg: "assets/images/shapes/testi-card-bg-1-2.png?v=20260924",
    bottomBgHover: "assets/images/shapes/testi-card-bg-1-2-hover.png?v=20260924",
    wowDelay: "200ms",
  },
  {
    topBg: "assets/images/shapes/testi-card-bg-1-1.png?v=20260924",
    rating: 5,
    content: (
      <>
        <span style={{ fontWeight: "bold", color: "black" }}>
          Exceptional
        </span>
        <br />
        We had a wonderful time at Hanthana House! The hotel is
        located in the beautiful hilltops of Kandy with lovely
        views, a nice place to stay away from the noise of the
        city.
        <br /><br />
      </>
    ),
    authorImg: "assets/images/reviews/Hols.jpg?v=20260924",
    authorName: "Silje",
    authorDesignation: "September 2024",
    bottomBg: "assets/images/shapes/testi-card-bg-1-2.png?v=20260924",
    bottomBgHover: "assets/images/shapes/testi-card-bg-1-2-hover.png?v=20260924",
    wowDelay: "300ms",
  },
  {
    topBg: "assets/images/shapes/testi-card-bg-1-1.png?v=20260924",
    rating: 5,
    content: (
      <>
        <span style={{ fontWeight: "bold", color: "black" }}>
          We will come back when we return through Sri Lanka
        </span>
        <br />
        I loved everything about this accommodation, the
        hospitality with which the whole family treats you, how
        careful they are in every corner and the dinners and
        breakfasts they prepare are delicious. We felt at home.
        The views also towards the mountain are unbeatable, you
        are 15 minutes from the city of Kandy but away from the
        bud, you are in the high area of mountains surrounded by
        lots of vegetation.
        <br /><br />
      </>
    ),
    authorImg: "assets/images/reviews/omikej.jpg?v=20260924",
    authorName: "Paula",
    authorDesignation: "December 2024",
    bottomBg: "assets/images/shapes/testi-card-bg-1-2.png?v=20260924",
    bottomBgHover: "assets/images/shapes/testi-card-bg-1-2-hover.png?v=20260924",
    wowDelay: "000ms",
  },
  {
    topBg: "assets/images/shapes/testi-card-bg-1-1.png?v=20260924",
    rating: 5,
    content: (
      <>
        <span style={{ fontWeight: "bold", color: "black" }}>
          Highly recommended
        </span>
        <br />
        Very nice hosts with good service. They even helped us
        with the rest of the planning of the holiday and gave us
        good tips on which Safari Tour is a good value for
        money. Also, the food was fantastic and they always
        arranged for us a tuk tuk driver and if necessary a
        taxi. The location offers a great view over the forest.
        Absolutely recommended!{" "}
      </>
    ),
    authorImg: "assets/images/reviews/hippie.jpg?v=20260924",
    authorName: "Tobias",
    authorDesignation: "December 2024",
    bottomBg: "assets/images/shapes/testi-card-bg-1-2.png?v=20260924",
    bottomBgHover: "assets/images/shapes/testi-card-bg-1-2-hover.png?v=20260924",
    wowDelay: "100ms",
  },
];

const Testimonials = () => {
  const [current, setCurrent] = useState(0);
  const total = testimonials.length;

  const handlePrev = () => setCurrent((prev) => (prev === 0 ? total - 1 : prev - 1));
  const handleNext = () => setCurrent((prev) => (prev === total - 1 ? 0 : prev + 1));

  return (
    <section
      className="testimonials-one"
      style={{ backgroundColor: "#D3C4A5" }}
    >
      <div className="container">
        <div className="row">
          <div className="col-lg-4">
            <div className="testimonials-one__content">
              <div className="sec-title text-left">
                <h6 className="sec-title__tagline">Guest reviews</h6>
                <h3 className="sec-title__title">
                  Heartfelt words from our past guests
                </h3>
              </div>
              <div className="testimonials-one__content__ratings">
                <i className="fa fa-star" />
                <i className="fa fa-star" />
                <i className="fa fa-star" />
                <i className="fa fa-star" />
                <i className="fa fa-star" />
              </div>
              {/* /.testimonials-average__ratings */}
              <p className="testimonials-one__content__text">
                <a
                  href="https://www.tripadvisor.com/Hotel_Review-g304138-d2036454-Reviews-Hanthana_House-Kandy_Kandy_District_Central_Province.html#REVIEWS"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: "white" }}
                >
                  <b>Trust Score 4.5 (Based on 444 Reviews)</b>
                </a>
              </p>
              {/* /.testimonials-custome-dots */}
               {/* Point navigation below ratings */}
              <div style={{ textAlign: "left", margin: "12px 0" }}>
                {testimonials.map((_, idx) => (
                  <span
                    key={idx}
                    style={{
                      display: "inline-block",
                      width: 10,
                      height: 10,
                      borderRadius: "50%",
                      margin: "0 4px",
                      background: idx === current ? "#ccc" : "#ffff",
                      cursor: "pointer"
                    }}
                    onClick={() => setCurrent(idx)}
                  />
                ))}
              </div>
            </div>
          </div>
          <div className="col-lg-8">
            <div style={{ position: "relative", minHeight: 420 }}>
              <div className="item" key={current}>
                <TestimonialsCard {...testimonials[current]} />
              </div>
             
            </div>
            {/* /.testimonials-one__carousel */}
          </div>
        </div>
      </div>
      {/* /.container */}
    </section>
  );
};

export default Testimonials;